import React, { useState } from 'react';
import './MenuPage.css';
import Hero from '../components/Hero';
import donkeyLogo from '../assets/donkey_logo.png';
import cocktailHeroImage from '../assets/cocktail-hero.jpg';
import placeholderImage from '../assets/placeholder.webp';

const DrinkMenu: React.FC = () => {
  const [modalImage, setModalImage] = useState<string | null>(null);
  const [modalAlt, setModalAlt] = useState<string>('');

  const openModal = (imageSrc: string, altText: string) => {
    setModalImage(imageSrc);
    setModalAlt(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAlt('');
  };

  const menuData = {
    houseDrinks: [
      {
        name: "El Gríngo",
        price: "$8.00",
        description: "A poor man's Michelada, this pint sized bebido combines a mexican lager with 3.0 oz of clamato and a couple dashes of hot sauce. Served with a tajin rim, lime garnish and the bottle on the side.",
        image: placeholderImage
      },
      {
        name: "Burbie's Marg-e",
        price: "$14.00",
        description: "Sweet with a touch of sour. This twist on a traditional Cadillac Margarita has a shot of Astral reposado tequila, full squeeze of lime and a splash of OJ/cranberry. Shaken and poured over fresh ice in a frozen goblet with a tajin rim and umbrella garnish to remind us the beach is never too far away from San Jose. Don't forget the topper of Grand Marnier! The legendary bartender Candice of Santa Cruz's wharf-top bar created these subtle differences and we improved it by adding more alcohol and putting it in the coldest glass in San Jose!!",
        image: placeholderImage
      },
      {
        name: "The Squirtski",
        price: "$13.00",
        description: "Named by Chicago based legend, friend, and restaurateur Paulie-G, this drink is a staple at one of his restaurants in Lincoln Park just outside the Windy City. Search for \"Gemini restaurant\" next time you're in Chi-Town! In short, this cocktail combines a flavorful grapefruit vodka, squirt soda from the bottle, and a squeeze of lime juice served atop fresh ice and garnished with a dehydrated fruit wheel.",
        image: placeholderImage
      },
      {
        name: "The 1A / 2A Happy Meal",
        price: "$14.00",
        description: "A tribute to our Founding Fathers and reference to the Bill of Rights. If 1A, an ice cold & fully dressed Pacifico doesn't do the trick you can fall back on 2A, a shot of Astral reposado tequila with one ice cube and a lime on the brim. The drink may not be American but the principal is!",
        image: placeholderImage
      },
      {
        name: "Unincorporated",
        price: "$16.00",
        description: "A French 75 spin-off with a shot of blanco tequila (instead of gin) and heavy topper of champagne. Founded in 1906, Burbanks unincorporated area has been home to 2 great hospitals, Valley Med and O'Connor. We pay tribute to the dedicated health care workers both here and around the country that have already proved capable of being a brave first line of defense against a future zombie invasion! Grab your uzi and join in the defense! The traditional French 75 combines a gin gimlet with a top of champagne.",
        image: placeholderImage
      },
      {
        name: "Furbanks",
        price: "$11.95",
        description: "A traditional Nigroni combines equal parts of Campari, Hendricks gin and sweet vermouth... and chilled in a giant ice cube! Named after our original mascot \"Furbanks\", a giant Maine Coon feline. May he rest in peace.",
        image: placeholderImage
      },
      {
        name: `The Bloody "Buddy" Mary`,
        price: "$13.00",
        description: `Named after "Buddy", our other mascot and corgi whose superpower is being the happiest dog in the world. Which begs the question, why did he eat Furbanks, our original mascot? A Bloody Mary with a house-made mix, traditional spices, and garnished with bacon and celery. Served in a pint glass with a seasoned rim and side-car shot for your friend who still says they don't like Bloody Mary's!`,
        image: placeholderImage
      },
      {
        name: "Santana Joe",
        price: "$16.00",
        description: "Our exceptional Espresso Martini is made using Chef Daniel's prized Rancilio-Epoca espresso machine and mixed with Kettle One. Garnished with an expressed mint leaf. Where would Santana Row be without San Jose!",
        image: placeholderImage
      },
      {
        name: "Old Man Mick-Dickle",
        price: "$14.00",
        description: "A mysterious and refreshing pickle-infused cocktail. Ask your bartender for the story!",
        image: placeholderImage
      },
      {
        name: "The California Chillem",
        price: "$9.00",
        description: `In memory of the late, great C.B. Hannegan's (1980 – Dec 28, 2017) who was "the place to be" in LG for nearly 40 years. This crisp refreshing "shooter" combines vodka and freshly squeezed grapefruit juice with a hit of soda water. Created by the legendary bartenders of Hannegan's who were renowned for being simple and effective, just like the drink.`,
        image: placeholderImage
      },
      {
        name: "The Little TJ",
        price: "$9.00",
        description: `Inspired by our neighbor, the "Buena Vista" district, this glorified beer features a Mexican lager bottle garnished with a small meal... a cooked shrimp dressed in salt, lime and a dash of hot sauce!!!`,
        image: placeholderImage
      }
    ],
    nonAlcoholic: [
      {
        name: "FOUNTAIN SODA",
        price: "$2.00",
        description: "Classic fountain sodas — Coke, Pepsi, Sprite, and more.",
        image: placeholderImage
      }
    ]
  };

  const categoryDisplayNames = {
    houseDrinks: "Burbank's: House Drinks",
    nonAlcoholic: "Non-Alcoholic Drinks"
  };

  return (
    <>
      <Hero title="Drinks" height="40vh" useClipPath={true} image={cocktailHeroImage} chevronLogo={donkeyLogo} />

      <div className="menu-page">
        {Object.entries(menuData).map(([categoryKey, items]) => (
          <section key={categoryKey} className="menu-category">
            <div className="category-header">
              <h2>{categoryDisplayNames[categoryKey as keyof typeof categoryDisplayNames]}</h2>
            </div>
            <div className="menu-items-grid">
              {items.map((item, itemIndex) => (
                <div key={itemIndex} className="menu-item-card">
                  <div className="menu-item-image-container" onClick={() => openModal(item.image, item.name)}>
                    <img src={item.image} alt={item.name} className="menu-item-image" />
                  </div>
                  <div className="menu-item-content">
                    <div className="menu-item-info">
                      <div className="menu-item-header">
                        <h3 className="menu-item-name">{item.name}</h3>
                        {item.price && <span className="menu-item-price">{item.price}</span>}
                      </div>
                      {item.description && (
                        <p className="menu-item-description">{item.description}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>

      {/* Modal */}
      {modalImage && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <img src={modalImage} alt={modalAlt} className="modal-image" />
            <p className="modal-caption">{modalAlt}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default DrinkMenu; 